export const ImageCropperMinScale = 1;
export const ImageCropperMaxScale = 5;
